import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export function TripleZeroMessage({ subject = "you are", emphasise = false }) {
    const Emphasis = emphasise ? "strong" : React.Fragment;
    return (_jsxs(_Fragment, { children: ["If ", subject, " experiencing a medical emergency, including chest pain or shortness of breath, or your consultation is for an infant under 3 months of age with a fever, ", _jsx(Emphasis, { children: "call 000" }), " and ask for an ambulance or attend your nearest emergency department immediately."] }));
}
